import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveSummaryCardMeta, formatHours } from './constants';

const SUMMARY_I18N = {
  HNO: { labelKey: 'summaryHno', hintKey: 'summaryHnoHint' },
  HO: { labelKey: 'summaryHo', hintKey: 'summaryHoHint' },
  Astreinte: { labelKey: 'summaryAstreinte', hintKey: 'summaryAstreinteHint' },
  Formation: { labelKey: 'summaryFormation', hintKey: 'summaryFormationHint' },
  Congés: { labelKey: 'summaryConges', hintKey: 'summaryCongesHint' },
  Absence: { labelKey: 'summaryAbsence', hintKey: 'summaryAbsenceHint' },
};

export default function SummaryCards({ summary = {}, declarationRate = 0, categories = null }) {
  const { t } = useTranslation('planning');
  const rate = Math.max(0, Math.min(100, Number(declarationRate) || 0));
  const rateLabel = Number(declarationRate || 0).toFixed(0);
  const cards = useMemo(
    () => resolveSummaryCardMeta(categories),
    [categories]
  );

  return (
    <div className="summary-cards">
      <div className="summary-cards-grid">
        {cards.map((card) => {
          const value = formatHours(summary[card.summaryKey] ?? 0);
          const i18nMeta = SUMMARY_I18N[card.summaryKey];
          const label = i18nMeta ? t(i18nMeta.labelKey) : card.label;
          const hint = i18nMeta ? t(i18nMeta.hintKey) : card.hint;
          return (
            <article
              key={card.id}
              className={`summary-metric-card summary-metric-card--${card.tone}`}
            >
              <div className="summary-metric-body">
                <div className="summary-metric-top">
                  <p className="summary-metric-label">{label}</p>
                  <div className="summary-metric-icon" aria-hidden="true">
                    <span className="material-symbols-outlined">{card.icon}</span>
                  </div>
                </div>
                <div className="summary-metric-value-row">
                  <p className="summary-metric-value">
                    {value}
                    <span className="summary-metric-unit">h</span>
                  </p>
                </div>
                <p className="summary-metric-hint">{hint}</p>
              </div>
            </article>
          );
        })}
      </div>

      <div className="summary-declaration-card">
        <div className="summary-declaration-top">
          <div className="summary-declaration-title-wrap">
            <span className="summary-declaration-icon" aria-hidden="true">
              <span className="material-symbols-outlined">bar_chart</span>
            </span>
            <div>
              <p className="summary-declaration-title">{t('declarationRate')}</p>
              <p className="summary-declaration-subtitle">{t('declarationRateSubtitle')}</p>
            </div>
          </div>
          <div className="summary-declaration-rate">
            <span className="summary-declaration-rate-value">{rateLabel}</span>
            <span className="summary-declaration-rate-unit">%</span>
          </div>
        </div>

        <div className="summary-declaration-track" aria-hidden="true">
          <div className="summary-declaration-fill" style={{ width: `${rate}%` }} />
        </div>

        <div className="summary-declaration-meta">
          <span>0%</span>
          {/* <span className="summary-declaration-cta">Tracking progress</span> */}
          <span>100%</span>
        </div>
      </div>
    </div>
  );
}
